import React from 'react';
import './IT_Service.css';
import { MdDataset, MdOutlineComputer, MdOutlineNetworkCheck, MdSecurity, MdSettings, MdWeb } from 'react-icons/md';
import { partners } from '../data/Data';

const IT_Service = () => {
  const services = [
    {
      id: 1,
      title: "Cloud Solutions",
      description: "Scalable cloud infrastructure and migration services",
      icon: "☁️"
    },
    {
      id: 2,
      title: "Cybersecurity",
      description: "Advanced security solutions for your business",
      icon: <MdSecurity />
    },
    {
      id: 3,
      title: "IT Support",
      description: "24/7 technical support and maintenance",
      icon: <MdOutlineComputer />
    },
    {
      id: 4,
      title: "Network Infrastructure",
      description: "Reliable network design and implementation",
      icon: <MdWeb />
    },
    {
      id: 5,
      title: "Software Development",
      description: "Custom software solutions tailored to your needs",
      icon: <MdSettings />
    },
    {
      id: 6,
      title: "Data Analytics",
      description: "Transform data into actionable insights",
      icon: <MdDataset />
    }
  ];

  return (
    <div className="it-service-container">
      {/* Background Elements */}
      <div className="background-elements">
        <div className="floating-circle circle-1"></div>
        <div className="floating-circle circle-2"></div>
        <div className="floating-circle circle-3"></div>
        <div className="floating-circle circle-4"></div>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        {/* Banner Background */}
        <div className="hero-banner-bg"></div>
        
        <div className="hero-content">
          <h1 className="hero-title">IT Services & Solutions</h1>
          <div className="hero-text-container">
            <p className="hero-subtitle">
              BAZRA's IT wing is working both on its own capacity and with international partners in the world of IT. BAZRA is partnering with such big names in the industry as ALT4, FORTECOM, GEOMIR, INFOWATCH, iPavlov, Kontur Talk, MPP LABS, Oraion AI, SAP LEONARDO, SODA – SYSTEMS INTEGRATION & DATA ANALYTICS, SOFTLINE SOFTCLUB, SOFTLOGIC, VOLTAH. BAZRA has developed its own logistics management and payment platforms.
            </p>
            <p className="hero-subtitle">
              BAZRA has developed a Logistics and Transport platform which is completely automated system that outperforms the industry's conventional management systems and enables businesses and truck owners to take full control of their assets, cargo and engage actively in the business. The platform provides market, tracing and tracking tools, transport administration and management.
            </p>
          </div>
          <div className="hero-buttons">
            <button className="btn-primary">Get Started</button>
            <button className="btn-secondary">Learn More</button>
          </div>
        </div>
      </section>


      {/* Partners Slider Section */}
      <section className="partners-section">
        <div className="partners-container">
          <h2 className="section-title">Our Technology Partners</h2>
          <p className="partners-subtitle">
            Collaborating with industry leaders to deliver exceptional IT solutions
          </p>
          <div className="partners-slider">
            <div className="partners-track">
              {partners[0].partners.concat(partners[0].partners).map((partner, index) => (
                <div key={index} className="partner-card">
                  <img 
                    src={partner.image_src} 
                    alt={partner.description}
                    className="partner-logo"
                    onError={(e) => {
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMTIwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iNjAiIGZpbGw9InJnYmEoMjI0LCAxNjgsIDEzLCAwLjEpIiByeD0iOCIvPjx0ZXh0IHg9IjYwIiB5PSIzMCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEwIiBmaWxsPSIjZTBhODBkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iMC4zNWVtIj5Mb2dvPC90ZXh0Pjwvc3ZnPg==';
                    }}
                  />
                  <p className="partner-name">{partner.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-section">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <button className="service-btn">Explore →</button>
            </div>
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="features-content">
          <div className="features-text">
            <h2>Why Choose Our IT Services?</h2>
            <ul className="features-list">
              <li>✅ 24/7 Professional Support</li>
              <li>✅ Cutting-edge Technology</li>
              <li>✅ Customized Solutions</li>
              <li>✅ Rapid Deployment</li>
              <li>✅ Cost-effective Pricing</li>
              <li>✅ Expert Team</li>
            </ul>
          </div>
          <div className="features-visual">
            <div className="tech-animation">
              <div className="server-rack">
                <div className="server-light"></div>
                <div className="server-light"></div>
                <div className="server-light"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Transform Your IT Infrastructure?</h2>
          <p>Contact us today for a free consultation</p>
          <button className="cta-button">Schedule a Call</button>
        </div>
      </section>
    </div>
  );
};

export default IT_Service;